import React from "react";

const WHATSAPP_NUMBER = "919327927782";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=Hi%20ETHIA!%20I%27m%20interested%20in%20your%20cultivated%20pet%20food.`;

const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-4 md:right-6 flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 group"
      style={{ zIndex: 10000 }}
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <div className="w-14 h-14 flex items-center justify-center">
        <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.132 6.744 3.054 9.378L1.056 31.2l6.06-1.944a15.922 15.922 0 008.888 2.688C24.828 31.944 32 24.77 32 16.004 32 7.174 24.828 0 16.004 0zm9.314 22.606c-.39 1.1-1.932 2.012-3.168 2.278-.846.18-1.95.324-5.668-1.218-4.76-1.972-7.822-6.81-8.06-7.124-.228-.314-1.918-2.554-1.918-4.87s1.214-3.456 1.644-3.928c.43-.472.94-.59 1.252-.59.312 0 .624.002.898.016.288.014.674-.11.954.728.39 1.1.94 2.686 1.02 2.882.08.196.136.426.028.682-.11.258-.164.418-.328.644-.164.226-.346.504-.492.676-.164.19-.336.394-.144.772.192.378.854 1.408 1.834 2.282 1.26 1.124 2.322 1.472 2.654 1.636.332.164.526.136.72-.082.192-.218.828-.964 1.048-1.296.22-.332.44-.274.744-.164.304.11 1.928.91 2.26 1.076.332.164.554.248.634.384.082.136.082.786-.308 1.886z"/>
        </svg>
      </div>
      <span className="hidden md:inline pr-5 font-semibold text-sm whitespace-nowrap">
        Chat with us
      </span>
    </a>
  );
};

export default WhatsAppButton;
